import {
  EyeOutlined,
  ShareAltOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';
import { FileOutlined, LinkOutlined } from '@vindr/icons';
import { StudyDataV2 } from '@vindr/services/apis/study.api';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
import { ItemType } from '@vindr/ui/src/components/ui/PopupContextMenu/PopupContextMenu';
import { useTranslation } from 'react-i18next';

export const MENU_TYPE = {
  OPEN_VIEWER: 'open',
  OPEN_VIEWER_AND_REPORT: 'open_viewer_and_report',
  OPEN_SPLIT_WINDOW: 'open_split',
  OPEN_SPLIT_WINDOW_AND_REPORT: 'open_split_window_and_report',
  BOOKMARK: 'bookmark',
  SHARE: 'share',
  OPEN_REPORT: 'open_report',
  ORDER_MATCH: 'order_match',
  SHARE_STUDY: 'share_study',
  ATTACHMENT_FILE: 'attachment_file',
};

const useContextMenu = ({
  handleContextMenuSelect,
}): ItemType<StudyDataV2>[] => {
  const { t } = useTranslation('Vindoc');
  // const { iframe } = useGlobalState();
  // const [iframeState] = iframe;

  const menuOpenViewer = [
    {
      key: MENU_TYPE.OPEN_VIEWER,
      label: t('Open Viewer'),
      icon: <EyeOutlined className="text-3xl" />,
      onClick: (record) =>
        handleContextMenuSelect(MENU_TYPE.OPEN_VIEWER, record),
      disabled: !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
    },
    // {
    //   key: MENU_TYPE.OPEN_VIEWER_AND_REPORT,
    //   label: t('Open Viewer and Report'),
    //   icon: <EyeOutlined className="text-3xl" />,
    //   onClick: (record) =>
    //     handleContextMenuSelect(MENU_TYPE.OPEN_VIEWER_AND_REPORT, record),
    //   disabled: !keycloak.hasOneOfPerm([PERMISSIONS.page.view_viewer]),
    // },
  ];

  return [
    ...menuOpenViewer,
    // {
    //   key: MENU_TYPE.SHARE_STUDY,
    //   label: t('Share Study'),
    //   icon: <ShareAltOutlined className="text-3xl" />,
    //   onClick: (record) =>
    //     handleContextMenuSelect(MENU_TYPE.SHARE_STUDY, record),
    //   disabled: !keycloak.hasOneOfPerm([PERMISSIONS.studylist.share]),
    // },
    // {
    //   key: MENU_TYPE.OPEN_REPORT,
    //   label: t('Open Report'),
    //   icon: <SnippetsOutlined className="text-3xl" />,
    //   onClick: (record) =>
    //     handleContextMenuSelect(MENU_TYPE.OPEN_REPORT, record),
    //   disabled: !keycloak.hasOneOfPerm([PERMISSIONS.studylist.report]),
    // },
    // {
    //   key: MENU_TYPE.ATTACHMENT_FILE,
    //   label: t('File Attachment'),
    //   icon: <FileOutlined className="text-3xl" />,
    //   onClick: (record) =>
    //     handleContextMenuSelect(MENU_TYPE.ATTACHMENT_FILE, record),
    //   disabled: !keycloak.hasOneOfPerm([PERMISSIONS.studylist.attachment_add]),
    // },
    // {
    //   key: MENU_TYPE.ORDER_MATCH,
    //   label: t('Match Order'),
    //   icon: <LinkOutlined className="text-3xl" />,
    //   onClick: (record) =>
    //     handleContextMenuSelect(MENU_TYPE.ORDER_MATCH, record),
    //   disabled: !keycloak.hasOneOfPerm([PERMISSIONS.studylist.match]),
    // },
  ];
};

export default useContextMenu;
